import config from '../../app-config';

export default class APIService {

    static getBackgrounds() {
        return fetch(config.URL + `/api/background/get-backgrounds`)
    }

    static getTypesSymbols(schematic_type_id) {
        return fetch(config.URL + `/api/symbol-type/get-symbols-type/${schematic_type_id}`)
    };

    static saveSchematic({json, document_name, schematic_type_id}) {
        return fetch(config.URL + `/api/schematics/save-schematic `, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({json, document_name, schematic_type_id})
        })
    }

    static saveLayout({json, document_name, schematic_type_id}) {
        return fetch(config.URL + `/api/schematics/save-layout `, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({json, document_name, schematic_type_id})
        })
    }

    static createDraft(schematic_type_id) {
        return APIService.saveSchematic({
            document_name: 'Draft project',
            schematic_type_id,
            json: {
                schematic_type_id,
                pages: [{
                    elements: [],
                }], activePage: 0
            }
        });
    }

    static getSchematic(id) {
        return fetch(config.URL + `/api/schematics/schematic-file/${id}`)
    }

    static getSchematicDraftId() {
        return fetch(config.URL + `/api/schematics/schematic-draft-id`)
    }

    static getSchematicsList() {
        return fetch(config.URL + `/api/schematics/list`)
    }

    static getSchematicTypes() {
        return fetch(config.URL + `/api/schematic_types`)
    }

    static getActiveSchematicType(id) {
        return fetch(config.URL + `/api/schematic_types/active_schematic_type/${id}`)

    }

    static removeSchematic(name) {
        return fetch(config.URL + `/api/schematics/schematic`, {
            method: 'delete',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({document_name: name})
        })

    }

    static sendFeedback(feedbackData, fileList) {
        const formData = new FormData()
        for (let key in feedbackData) {
            formData.append(key, feedbackData[key]);
        }
        fileList.forEach((image, index) => {
            formData.append('image-' + index, image.originFileObj);
        })

        return fetch(config.URL + `/api/feedback/send-feedback`, {
            method: 'post',
            body: formData
        })
    }
}
